/* eslint-disable quotes */
/* eslint-disable radix */
/* eslint-disable import/no-duplicates */
/* eslint-disable no-unused-vars */
/*  eslint-disable jsx-a11y/click-events-have-key-events */
/*  eslint-disable jsx-a11y/no-static-element-interactions */

import { Container, Grid, Typography, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, Link, useNavigate, NavLink } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import ExpandLessSharpIcon from "@mui/icons-material/ExpandLessSharp";
import SearchSharpIcon from "@mui/icons-material/SearchSharp";
import CloseIcon from "@mui/icons-material/Close";
import ResponsiveMenu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Hidden from "@mui/material/Hidden";
import TopBarMenu from "./topBarMenu";
import MobileMenu from "./mobileMenu";
import Logo from "./logo";
import Menu from "./menu";
import "./header.scss";
import menuBeforeLogin from "../../api/menu.json";
import { getDynamicMenu } from "../../services/Login";
import userService from "../../services/Login/index";
import { setIsDropship } from "./setDropshipFlag";
import { getEPEnabledAccounts } from "../../services/common";
import { isLinkInArray, publicRoute } from "../../utils/common";
import i18n from "../../i18n";
import SwitchAccount from "./SwitchAccount";
import userLogin from "../../utils/userLogin";
import FilterUser from "../../pages/place-order/filterUser";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "sticky",
    zIndex: 1000,
    top: "0px",
    background: "white",
    boxShadow: "0 0 4px 0 rgba(0,0,0,0.5)",
    borderBottom: "1px solid #ccc",
  },
  headerContainer: {
    padding: theme.spacing(2),
    alignItems: "center",
    justifyContent: "center",
  },
  mainMenuBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  contctUs: {
    fontSize: theme.spacing(2),
    "& a": {
      color: "#000",
    },
  },
  btn: {
    marginLeft: theme.spacing(1),
    borderRadius: theme.spacing(0),
    textTransform: "none",
    fontSize: theme.spacing(1.75),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    fontFamily: "CernLight",
  },
}));
const menuItemsArr = [
  "/order",
  "/order-history",
  "/dva",
  "/drafts",
  "/claims",
  "/return",
  "/dvaManualForms",
  "/return-history",
  "/mask-guarantee",
  "/mask-guarantee-history",
  "/warranty",
  "/payments",
  "/pageNotFound",
  "/accessDenied",
  "/new-account",
  "/reset-password",
  "/contact-us",
  "my-account",
  "my-company",
];
const header = React.memo(() => {
  const location = useLocation();
  const classes = useStyles();
  const login = useSelector((state) => state.authentication);
  const { freezePeriod } = useSelector((state) => state.cartDetails);
  const setUser = useSelector((state) => state.setUser);
  const { user, error401, myAccountPermission, myCompanyPermission } =
    useSelector((state) => state.authentication);
  const orgId = useSelector((state) => state?.authentication?.user?.CP_ORGID);
  const country = useSelector(
    (state) => state?.authentication?.user?.CP_COUNTRY
  );
  const isContactUsPage = location.pathname.endsWith("/contact-us");
  const showAuthenticatedMenu =
    login?.loggedIn && (!isLinkInArray(publicRoute) || isContactUsPage);
  const isServiceCenterUser = useSelector(
    (state) => state.setUser.userPermision?.IS_ACTIVE_SERVICE_CENTRE_ACC
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { VITE_REDIRECT_TO_OLD_URL, VITE_AU_HEADER_BASE_URL } = import.meta.env;

  useEffect(() => {
    // ?code= is stripped from the URL immediately by okta.js to prevent
    // history/referrer leakage. Use the oauth_callback sessionStorage flag
    // as the post-login navigation signal instead.
    const isOAuthCallback = sessionStorage.getItem('oauth_callback') === 'true';

    if (isOAuthCallback) {
      sessionStorage.removeItem('oauth_callback');
      const redirectUrl = localStorage.getItem("redirectUrl");
      if (redirectUrl) {
        navigate(redirectUrl);
      }
    }
  }, [navigate]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location?.search);

    if (searchParams?.has("user")) {
      searchParams.delete("user");

      navigate(
        {
          pathname: location?.pathname,
          search: searchParams?.toString()
            ? `?${searchParams?.toString()}`
            : "",
          hash: location?.hash,
        },
        { replace: true }
      );
    }
  }, [location?.pathname, location?.search, location?.hash, navigate]);

  useEffect(() => {
    const checkAuthAndRoutes = async () => {
      try {
        const someRoutesCheck = menuItemsArr.some((a) =>
          window.location.pathname.includes(a)
        );
        if (!someRoutesCheck) {
          navigate("/login");
          return;
        }
        if (!orgId && !localStorage.getItem("ispaynowSet")) {
          await userLogin.queryUserAuth({ dispatch });
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
      }
    };
    checkAuthAndRoutes();
  }, [orgId]);

  const checkAccountSwitchRedirect = (menu) => {    
    if (!setUser?.accountSwitched) {
      return;
    }
  
    const currentPath = location.pathname;
  
  
    const fallbackPriority = [
      "/order",
      "/return",
      "/mask-guarantee",
      "/warranty",
      "/order-history",
      "/return-history",
      "/mask-guarantee-history",
      "/payments",
      "/dva",
      "/drafts",
      "/claims",
      "/dvaManualForms",
    ];
  
    const enabledRoutes = [];
  
    const checkMenuItems = (items = []) => {
      items.forEach((item) => {
        if (item?.["account-enabled"] === true && item?.link) {
          enabledRoutes.push(item.link);
        }
  
        if (item?.["sub-menu"]?.length) {
          checkMenuItems(item["sub-menu"]);
        }
  
        if (item?.["second-level-sub-menu"]?.length) {
          checkMenuItems(item["second-level-sub-menu"]);
        }
      });
    };
  
    checkMenuItems(menu);    
  
    if (enabledRoutes.includes(currentPath)) {
      return;
    }
  
    const fallbackRoute = fallbackPriority.find((route) =>
      enabledRoutes.includes(route)
    );
  
    if (fallbackRoute) {
      navigate(fallbackRoute, { replace: true });
    } else {
      navigate("/accessDenied", { replace: true });
    }
  };

useEffect(() => {
    if (
      (!setUser?.accountSwitched && orgId && setUser?.accountNumber) ||
      (setUser?.accountSwitched && !setUser?.isCSR && !setUser?.isSalesRep)
    ) {
      const links = {
        "place.order": {
          enable: "/order",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/order.htm`,
        },
        "order.history": {
          enable: "/order-history",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/track_ship.htm`,
        },
        payments: {
          enable: "/payments",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/payments.htm`,
        },
        "mask.gaurantee": {
          enable: "/mask-guarantee",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/mask_guarantee.htm`,
        },
        "mask.gaurantee.history": {
          enable: "/mask-guarantee-history",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/track_ship.htm?type=return_mg`,
        },
        warranty: {
          enable: "/warranty",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/warranty.htm`,
        },
        "create.return": {
          enable: "/return",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/track_returns.htm`,
        },
        "return.history": {
          enable: "/return-history",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/track_ship.htm?type=return`,
        },
        "credit.claim.dva": {
          enable: "/dva",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/creditClaimDva.htm`,
        },
        // 'credit.claim.dva': { enable: '/dva', notEnable: `${REACT_APP_REDIRECT_TO_OLD_URL}/creditClaimDva.htm` },
        "credit.claim.dva.new": {
          enable: "/dva",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/creditClaimDva.htm`,
        },
        "credit.claim.draft": {
          enable: "/drafts",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/creditClaimDva.htm`,
        },
        "credit.claim.history": {
          enable: "/claims",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/creditClaimDva.htm`,
        },
        "credit.claim.manual.form": {
          enable: "/dvaManualForms",
          notEnable: `${VITE_REDIRECT_TO_OLD_URL}/dvaManual.htm`,
        },
      };
      getDynamicMenu(setUser?.accountNumber).then((resp) => {
        dispatch(setIsDropship(resp?.data?.["is-dropship"]));
        resp?.data?.menu?.forEach((ele) => {
          if (links?.[ele?.name] && ele["account-enabled"] === true) {
            ele.link = links?.[ele?.name]?.enable;
            ele.type = "Link";
          } else if (links?.[ele?.name] && ele?.["account-enabled"] === false) {
            ele.link = links?.[ele?.name]?.notEnable;
            ele.type = "a";
          } else if (ele?.["sub-menu"]) {
            ele?.["sub-menu"]?.forEach((el) => {
              if (links?.[el?.name] && el?.["account-enabled"] === true) {
                el.link = links?.[el?.name]?.enable;
                el.type = "Link";
              }
              if (links?.[el?.name] && el?.["account-enabled"] === false) {
                el.link = links?.[el?.name]?.notEnable;
                el.type = "a";
              }
              if (
                (el?.name === "credit.claim.title" ||
                  el?.name === "credit.claim.dva" ||
                  el?.name === "credit.claim.manual.form") &&
                el?.["account-enabled"] === true
              ) {
                el.link = links?.[el?.name]?.notEnable;
                el.type = "a";
              }
              if (
                el?.name === "order.history" ||
                el?.name === "place.order" ||
                el?.name === "payments" ||
                el?.name === "create.return" ||
                el?.name === "return.history" ||
                el?.name === "warranty" ||
                el?.name === "mask.gaurantee" ||
                el?.name === "mask.gaurantee.history" ||
                el?.name === "credit.claim.dva.new" ||
                el?.name === "credit.claim.dva" ||
                el?.name === "credit.claim.manual.form"
              ) {
                if (
                  (el?.name === "create.return" ||
                    el?.name === "return.history" ||
                    el?.name === "warranty") &&
                  (isServiceCenterUser === "Y" ||
                    el?.["account-enabled"] === false)
                ) {
                  el.link = links?.[el?.name]?.notEnable;
                  el.type = "a";
                } else if (
                  (el?.name === "mask.gaurantee" ||
                    el?.name === "mask.gaurantee.history") &&
                  el?.["account-enabled"] === false
                ) {
                  el.link = links?.[el?.name]?.notEnable;
                  el.type = "a";
                } else if (el?.["account-enabled"] !== false) {
                  el.link = links?.[el?.name]?.enable;
                  el.type = "Link";
                }
                if (el?.name === "mask.gaurantee") {
                  el.name = "mask.gaurantee.index";
                }
              } else {
                el.type = "a";
              }
              // Process second-level submenus
              if (el?.["second-level-sub-menu"]) {
                el["second-level-sub-menu"].forEach((secondLevelItem) => {
                  if (secondLevelItem?.["account-enabled"] === false) {
                    secondLevelItem.type = "a";
                    if (links?.[secondLevelItem?.name]) {
                      secondLevelItem.link = links?.[secondLevelItem?.name]?.notEnable;
                    }
                  } else {
                    secondLevelItem.type = "Link";
                    if (links?.[secondLevelItem?.name] && secondLevelItem?.["account-enabled"] === true) {
                      secondLevelItem.link = links?.[secondLevelItem?.name]?.enable;
                      secondLevelItem.type = "Link";
                    }
                  }
                  // Special handling for credit claim items in second-level
                  if (
                    (secondLevelItem?.name === "credit.claim.title" ||
                      secondLevelItem?.name === "credit.claim.dva" ||
                      secondLevelItem?.name === "credit.claim.manual.form") &&
                    secondLevelItem?.["account-enabled"] === true
                  ) {
                    secondLevelItem.link = links?.[secondLevelItem?.name]?.notEnable;
                    secondLevelItem.type = "a"; // These special cases should be 'a' even when enabled
                  }
                  // Handle specific menu items with complex logic for second-level
                  const complexMenuItems = [
                    "order.history",
                    "place.order",
                    "payments",
                    "create.return",
                    "return.history",
                    "warranty",
                    "mask.gaurantee",
                    "credit.claim.history",
                    "mask.gaurantee.history",
                    "credit.claim.dva.new",
                    "credit.claim.draft",
                    "credit.claim.manual.form",
                  ];
                  if (complexMenuItems.includes(secondLevelItem?.name) && secondLevelItem?.["account-enabled"] !== false) {
                    const returnWarrantyItems = [
                      "create.return",
                      "return.history",
                      "warranty",
                    ];
                    const maskGuaranteeItems = [
                      "mask.gaurantee",
                      "mask.gaurantee.history",
                    ];
                    if (
                      returnWarrantyItems.includes(secondLevelItem?.name) &&
                      (isServiceCenterUser === "Y" ||
                        secondLevelItem?.["account-enabled"] === false)
                    ) {
                      secondLevelItem.link = links?.[secondLevelItem?.name]?.notEnable;
                      secondLevelItem.type = "a"; // Set to 'a' for disabled state
                    } else if (
                      maskGuaranteeItems.includes(secondLevelItem?.name) &&
                      secondLevelItem?.["account-enabled"] === false
                    ) {
                      secondLevelItem.link = links?.[secondLevelItem?.name]?.notEnable;
                      secondLevelItem.type = "a"; // Set to 'a' for disabled state
                    } else if (secondLevelItem?.["account-enabled"] !== false) {
                      secondLevelItem.link = links?.[secondLevelItem?.name]?.enable;
                      secondLevelItem.type = "Link"; // Set to 'Link' for enabled state
                    }
                    // Special name handling
                    if (secondLevelItem?.name === "mask.gaurantee") {
                      secondLevelItem.name = "mask.gaurantee.index";
                    }
                  }
                  // Special cases that should always be type 'a'
                  if (
                    secondLevelItem?.name === "return.center" ||
                    secondLevelItem?.name === "credit.claim.title"
                  ) {
                    secondLevelItem.type = "a";
                  }
                });
              }
            });
          }
          if (
            (ele?.name === "order.history" ||
            ele?.name === "place.order" ||
            ele?.name === "create.return" ||
            ele?.name === "return.history" ||
            ele?.name === "warranty" ||
            ele?.name === "payments" ||
            ele?.name === "credit.claim.title" ||
            ele?.name === "credit.claim.dva" ||
            ele?.name === "credit.claim.manual.form") &&
            ele?.["account-enabled"] !== false  // Only process if not disabled
          ) {
            if (
              ele?.name === "warranty" &&
              isServiceCenterUser === "Y"
            ) {
              ele.link = links?.[ele?.name]?.notEnable;
              ele.type = "a";
            } else {
              ele.link = links?.[ele?.name]?.enable;
              ele.type = "Link";
            }
          }
          if (
            ele?.name === "warranty" &&
            ele?.["account-enabled"] === false
          ) {
            ele.link = links?.[ele?.name]?.notEnable;
            ele.type = "a";
          }
          if (ele?.name === "return.center") {
            ele.type = "a";
          }
          if (ele?.name === "credit.claim.title") {
            ele.type = "a";
          }
        });
        dispatch({ type: "MENU_ITEMS", payload: resp?.data.menu });
        if (setUser?.accountSwitched) {
          checkAccountSwitchRedirect(resp?.data?.menu);
        }
      });
   
    }
  }, [setUser?.accountNumber]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event?.currentTarget);
  };

  const clickSearch = () => {
    dispatch({ type: "PRODUCT_SEARCH", payload: true });
    dispatch({ type: "IS_PRODUCT_CATALOG", payload: false });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSignout = () => {
    const mydate = new Date();
    mydate.setTime(mydate.getTime() - 1);
    document.cookie = `selectedAccount=; expires=${mydate.toGMTString()}`;
    userService.logout();
  };
  const handleMyCompanyClick = () => {
    history("/my-company");
    setAnchorEl(null);
  };
  return (
    <header className={classes?.root}>
      <Hidden lgUp>
        <Grid className={classes?.headerContainer} container>
          <Grid item xs={1} className={classes?.setPadding}>
            {showAuthenticatedMenu ? (
              <MobileMenu />
            ) : ["/reset-password", "/new-account", "/help"].includes(
                location?.pathname
              ) ? (
              <MobileMenu dynamicMenu={menuBeforeLogin} />
            ) : !error401 ? (
              <Typography component="p" className={classes?.contctUs}>
                <b>{i18n.t("common.labels.questions")}?</b>{" "}
                <Link to="/contact-us">{i18n.t("HeaderLinks.contactUs")}</Link>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  className={classes?.btn}
                >
                  {i18n.t("HeaderLinks.signUp")}
                </Button>
              </Typography>
            ) : (
              ""
            )}
          </Grid>
          <Grid item xs={2} className={classes?.setPadding}>
            {showAuthenticatedMenu && (
              <>
                <PersonIcon
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  fontSize="small"
                />
                <ExpandLessSharpIcon fontSize="small" />

                <ResponsiveMenu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  className="responsiveMenu"
                >
                  <MenuItem onClick={handleClose}>
                    <CloseIcon fontSize="small" />
                  </MenuItem>
                  {user && (
                    <MenuItem>
                      <SwitchAccount loginUserInfo={user} user={setUser} />
                    </MenuItem>
                  )}
                  {myAccountPermission === "Y" ? (
                    <MenuItem>
                      <NavLink
                        to="/my-account"
                        className="nav-link"
                        id="TopMenu-LNK-myAccount"
                      >
                        {" "}
                        {i18n.t("menuTitle.myAccount")}
                      </NavLink>
                    </MenuItem>
                  ) : (
                    <MenuItem>
                      <a
                        href={`${VITE_REDIRECT_TO_OLD_URL}/myAccount.htm`}
                        id="TopMenu-LNK-myAccount"
                      >
                        {i18n.t("menuTitle.myAccount")}
                      </a>
                    </MenuItem>
                  )}
                  {myCompanyPermission === "Y" ? (
                    <MenuItem>
                      <NavLink
                        to="/my-company"
                        className="nav-link"
                        id="TopMenu-LNK-myCompany"
                      >
                        {" "}
                        {i18n.t("menuTitle.myCompany")}
                      </NavLink>
                    </MenuItem>
                  ) : (
                    <MenuItem>
                      <a
                        href={`${VITE_REDIRECT_TO_OLD_URL}/myCompany.htm`}
                        id="TopMenu-LNK-myCompany"
                      >
                        {i18n.t("menuTitle.myCompany")}
                      </a>
                    </MenuItem>
                  )}
                  {country === "AU" && (
                    <MenuItem>
                      <a
                        href={`${VITE_AU_HEADER_BASE_URL}/rad-launch-pad?utm_source=ros`}
                        target="_blank"
                        rel="noreferrer"
                        id="TopMenu-LNK-rad"
                        onClick={handleClose}
                      >
                        {i18n.t("menuTitle.rad")}
                      </a>
                    </MenuItem>
                  )}
                  <MenuItem>
                    <a
                      href={`${VITE_REDIRECT_TO_OLD_URL}/help/index.html`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      {i18n.t("menuTitle.help")}
                    </a>
                  </MenuItem>
                  <MenuItem>
                    <a onClick={handleSignout}>{i18n.t("menuTitle.logout")}</a>
                  </MenuItem>
                </ResponsiveMenu>
              </>
            )}
          </Grid>
          <Grid item xs={4} className="logoContainer">
            <Logo />
          </Grid>
          <Grid item xs={1} className={classes?.setPadding}>
            {location.pathname === "/order" && (
              <SearchSharpIcon
                fontSize="small"
                id="HP-BTN-Product-SearchIcon"
                onClick={clickSearch}
              />
            )}
          </Grid>
        </Grid>
      </Hidden>
      <Hidden mdDown>
        {showAuthenticatedMenu && (
          <TopBarMenu />
        )}
        <div className="freezePeriod-bar">
          {freezePeriod && <FilterUser freezePeriod={freezePeriod} />}
        </div>
        <Container className={classes?.mainMenuBox} maxWidth="lg">
          <Logo login={showAuthenticatedMenu} />
          {showAuthenticatedMenu ? (
            <Menu />
          ) : ["/reset-password", "/new-account", "/help"].includes(
              location?.pathname
            ) ? (
            <Menu menu={menuBeforeLogin} />
          ) : !error401 ? (
            <Typography component="p" className={classes?.contctUs}>
              <b>{i18n?.t("common.labels.questions")}?</b>{" "}
              <Link to="/contact-us">{i18n?.t("HeaderLinks.contactUs")}</Link>
              <Button
                variant="contained"
                color="primary"
                size="small"
                className={classes?.btn}
              >
                {i18n?.t("HeaderLinks.signUp")}
              </Button>
            </Typography>
          ) : (
            ""
          )}
        </Container>
      </Hidden>
    </header>
  );
});

export default header;
